'use client'
import type { ReactNode } from 'react'
import { Box, type BoxProps, Text, VStack } from '@chakra-ui/react'

interface GrandFormSectionProps extends Omit<BoxProps, 'title'> {
  title?: ReactNode
  description?: ReactNode
  children: ReactNode
}

/**
 * Semantic fieldset wrapper for a group of related form fields. Chakra v2
 * doesn't ship a Fieldset primitive (v3 does); we render a real `<fieldset>`
 * with an accessible `<legend>` plus optional helper text. The visual layout
 * is a stacked column — fields render in the order provided.
 */
export const GrandFormSection = ({
  title,
  description,
  children,
  ...props
}: GrandFormSectionProps) => {
  return (
    <Box as="fieldset" border={0} m={0} p={0} w="full" {...props}>
      {title ? (
        <Box as="legend" fontWeight="semibold" mb={1}>
          {title}
        </Box>
      ) : null}
      {description ? (
        <Text color="text.mild" fontSize="sm" mb={3}>
          {description}
        </Text>
      ) : null}
      <VStack align="stretch" spacing={4} w="full">
        {children}
      </VStack>
    </Box>
  )
}
